import { render, staticRenderFns } from "./headSet.vue?vue&type=template&id=4e7d05e0&scoped=true&"
import script from "./headSet.vue?vue&type=script&lang=js&"
export * from "./headSet.vue?vue&type=script&lang=js&"
import style0 from "./headSet.vue?vue&type=style&index=0&id=4e7d05e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d05e0",
  null
  
)

export default component.exports